// Media addresses (02-building-blocks.md, "Media addresses"): mxc to a download or cropped
// thumbnail address, on the authenticated endpoints when the server announces them (the service
// worker adds the token).
import type { MatrixClient } from 'matrix-js-sdk';
import { server } from '../core/server';

/** A cropped thumbnail at twice the drawn size; undefined without a picture. */
export function thumbnail(client: MatrixClient, mxc: string | null | undefined, size: number): string | undefined {
  if (!mxc) return undefined;
  return client.mxcUrlToHttp(mxc, size * 2, size * 2, 'crop', false, true, server.features.authenticatedMedia) ?? undefined;
}
